var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.62488H5.77906C4.79923 1.62488 4.00768 2.62586 4.00768 3.84754L4 19.4022C4 20.6239 4.79155 21.6249 5.76753 21.6249H18.2209C19.1969 21.6249 20 20.6239 20 19.4022V8.29286L14.6667 1.62488ZM5.77906 19.4022V3.84754H13.7791V7.82783C13.7791 8.69877 14.4131 9.40419 15.1969 9.40419H18.2209V19.4062H5.77906V19.4022ZM9.33718 13.4436H14.6667C15.1547 13.4436 15.5543 13.0377 15.5543 12.5333C15.5543 12.0328 15.1585 11.6229 14.6667 11.6229H9.33333C8.84534 11.6229 8.44573 12.0288 8.44573 12.5333C8.44573 13.0337 8.8415 13.4436 9.33333 13.4436H9.33718ZM9.33718 17.0534H14.6667C15.1547 17.0534 15.5543 16.6475 15.5543 16.1431C15.5543 15.6426 15.1585 15.2328 14.6667 15.2328H9.33333C8.84534 15.2328 8.44573 15.6387 8.44573 16.1431C8.44573 16.6436 8.8415 17.0534 9.33333 17.0534H9.33718Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReports);
export default __webpack_public_path__ + "static/media/MenuReports.86c6a274875fa4891c93eca6e4d85288.svg";
export { ForwardRef as ReactComponent };